import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	cardData: [
		{
			id_Alerta: "",
			id_Site: "",
			id_Subsite: "",
			nome: "",
			descricao: "",
			sqlquey_Alerta: "",
			sqlquery_Notificacao: "",
			activo: "",
			envia_Notificacao: "",
			tipo_Alerta: "",
			id_Rel: "",
			m_Utilizador: "",
			m_Data: "",
			lingua: "",
			url_Relatorio: "",
			classe_Icon: "",
			ordem: "",
			site: null,
			subSite: null,
			alertItem: {
				n: "",
				alert: "",
				report: "",
				class_Icon: "",
				alert_Order: "",
			},
		},
	],
};

const cardNotificationsSlice = createSlice({
	name: "cardNotifications",
	initialState: initialState,
	reducers: {
		updateCard(state, action) {
			// console.log("update cardNotifications");
			// console.log(action);

			state.cardData = action.payload;
		},
	},
});

export const cardNotificationsActions = cardNotificationsSlice.actions;

export default cardNotificationsSlice;
